import { render, staticRenderFns } from "./ModalChangeGroupDelivery.vue?vue&type=template&id=720db89c&"
import script from "./ModalChangeGroupDelivery.vue?vue&type=script&lang=js&"
export * from "./ModalChangeGroupDelivery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports